import API from 'api';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setPricing } from 'Reducers/pricingReducer';

const usePricing = () => {
    const dispatch = useDispatch();
    const pricing = useSelector((state) => state.pricing.data);

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (pricing && Object.keys(pricing).length > 0) return; // Don't fetch again

        setLoading(true);
        API.pricing.getPricing()
            .then((res) => {
                const data = res.data?.data?.subscriptionTemplates
                // this below chunk of code formats the data into proper "key:value" pair for mapping at FE.
                if (data) {
                    const grouped = data.reduce((acc, curr) => {
                        const role = curr.roleType;              // "advisor" or "client"
                        const type = curr.subscriptionType;      // "Alt Funds", "Premium", etc.

                        if (!acc[role]) {
                            acc[role] = {}; // initialize role bucket
                        }
                        if (!acc[role][type]) {
                            acc[role][type] = []; // initialize subscriptionType bucket under role
                        }
                        acc[role][type].push(curr);

                        return acc;
                    }, {});
                    if (Object.keys(grouped).length > 0) {
                        dispatch(setPricing(grouped));
                        // dispatch(setPricing(res));
                    }
                }
                // console.log("res => ", res)
            })
            .catch((err) => {
                setError(err.message);
            })
            .finally(() => {
                setLoading(false);
            });
    }, [pricing, dispatch]);

    return { pricing, loading, error };
};

export default usePricing;
